module.exports = __webpack_public_path__ + "static/jack-278306a0a24c18c23569131d7ce7328d.png";